import { Empty } from "antd";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";
import { SearchResults, SearchResultsStyles } from "./SearchResults";
import { ContentRowStyles } from "./SearchDirectory.styles";
import { sortGroupByPagesResults } from "../helper";

export const SearchDirectoryStyles = css`
  .searchDirectory {
    .searchDirectory__content-row {
      ${ContentRowStyles}
      ${SearchResultsStyles}
    }
  }
`;

function SearchDirectory({
    // parent
    visible = false,
    searchResults,
    clearAndCloseModal,
    // redux
    transactions,
}) {
    // const [radioValue, setRadioValue] = useState("all");
    // console.log('aaa globalSearch', { searchResults, transactions });
    let pagesSearchResults = sortGroupByPagesResults(searchResults.filter(r => r.score < 0.7));
    pagesSearchResults = pagesSearchResults.slice(0, 10); // top 10 results

    const noPagesFound = !pagesSearchResults.length;
    const noTransactionsFound = !transactions.length;
    const hasResults = !noPagesFound || !noTransactionsFound;

    // // visual side effects
    // useEffect(() => {
    //     if (noPagesFound && radioValue === "pages")
    //         setRadioValue("all");
    // }, [noPagesFound, radioValue]);

    console.log("aaa render SearchDirectory");
    return (
        <div className={`searchDirectory ${!visible ? "display-none" : ""}`}>
            {/* <Row className="searchDirectory__filter-row">
                <Radio.Group
                    defaultValue="all"
                    value={radioValue}
                    onChange={e => setRadioValue(e.target.value)}
                    buttonStyle="solid"
                >
                    {filterButtons(pagesSearchResults).map(renderRadioButton)}
                </Radio.Group>
            </Row> */}
            <div className="searchDirectory__content-row">
                <Empty
                    className={`content-row__empty ${
                        hasResults ? "display-none" : ""
                    }`}
                />
                <SearchResults
                    visible={hasResults}
                    searchResults={{
                        // max of 10 closest results for pages
                        pages: pagesSearchResults,
                        transactions,
                    }}
                    clearAndCloseModal={clearAndCloseModal}
                />
                {/* <TransactionsTable visible={radioValue === "transactions"} /> */}
            </div>
        </div>
    );
}

export default connect(state => ({
    transactions: state.Search.transactions,
}), {})(SearchDirectory);

//  DEPRECATED
// const filterButtons = pagesSearchResults => [
//     {
//         key: "all",
//         iconLeft: <BarsOutlined />,
//         title: <Trans>All Results</Trans>,
//     },
//     {
//         key: "transactions",
//         iconLeft: <DollarCircleOutlined />,
//         title: <Trans>Transactions</Trans>,
//     },
//     {
//         key: "pages",
//         iconLeft: <FileTextOutlined />,
//         title: <Trans>Pages</Trans>,
//         disabled: !pagesSearchResults.length,
//     },
// ];

// const renderRadioButton = (btn, transactions, radioValue) => (
//     <Radio.Button value={btn.key} disabled={btn.disabled}>
//         <span className="filter-row__btn-title">
//             {btn.iconLeft}
//     &nbsp;
//             {btn.title}
//             {btn.key === "transactions" ? (
//                 <Badge
//                     className={`filter-row__badge-counter ${
//                         radioValue === "transactions" ? "selected" : ""
//                     }`}
//                     count={transactions.length}
//                     showZero
//                     size="small"
//                 />
//             ) : null}
//         </span>
//     </Radio.Button>
// );
